import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

const DescriptionTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 0;
  margin-bottom: ${primitive.$spacing2};
`;

export default DescriptionTitle;
